module.exports = __webpack_public_path__ + "img/appointment@2x.7ef363a.webp";